import { render, staticRenderFns } from "./dokDowndrop.vue?vue&type=template&id=082bf286&scoped=true&"
import script from "./dokDowndrop.vue?vue&type=script&lang=js&"
export * from "./dokDowndrop.vue?vue&type=script&lang=js&"
import style0 from "./dokDowndrop.vue?vue&type=style&index=0&id=082bf286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082bf286",
  null
  
)

export default component.exports